// @ts-strict-ignore
import { DiagramColours } from '../../../../base-styles/diagram-colours';
import { Sector } from '../../../../model/sector';

export function groupColourToSector(defaultSector: Sector, groupColour?: string): Sector {
  if (!groupColour) {
    return defaultSector;
  }

  const diagramColour = DiagramColours.find((c) => c.id === groupColour);

  if (!diagramColour) {
    return defaultSector;
  }

  return diagramColour.sector ?? defaultSector;
}
